export default __webpack_public_path__ + "static/media/woman.48ecafb3.jpg";